import { render, staticRenderFns } from "./home-services.vue?vue&type=template&id=1110c1a5&"
import script from "./home-services.vue?vue&type=script&lang=js&"
export * from "./home-services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports